import * as React from 'react';
import { DatePeriod } from '../CardHistory';
import { CardType } from '../../../types/LibraryCard';
import Check from '@material-ui/icons/Check';
import Schedule from '@material-ui/icons/Schedule';
import Play from '@material-ui/icons/PlayArrow';
import { getReadableCardType, getDatePeriod, MOBILE_MAX_WIDTH } from '../../../utils';
import './CardHistoryItem.css';
import cn from 'classnames';
import OutsideClickHandler from 'react-outside-click-handler';
import { useMediaQuery } from 'react-responsive';

interface Props {
	period: DatePeriod;
	remove: (id: number) => void;
	goToCalendar: (start: any) => void;
	edit: () => void;
	editHistory: (history: DatePeriod) => void;
}

const CardHistoryItem: React.FC<Props> = ({ period, remove, goToCalendar, edit, editHistory }) => {
	const [controlsVisible, setControls] = React.useState(false);
	const isDesktop = useMediaQuery({ minWidth: MOBILE_MAX_WIDTH })

	const datePeriod = getDatePeriod(period.start, period.end, "с ", " по ", period.type === CardType.WantRead);

	const onClick = () => {
		setControls(true);
	}

	return (
		<div
			className={cn("cardHistoryItem-wrapper", {
				"cardHistoryItem-wrapper_readed": period.type === CardType.AlreadyRead,
				"cardHistoryItem-wrapper_want": period.type === CardType.WantRead,
				"cardHistoryItem-wrapper_read": period.type === CardType.ReadNow,
			})}
			onClick={onClick}
		>
			<OutsideClickHandler onOutsideClick={() => setControls(false)}>
				<div className="cardHistoryItem-wrapper__inside">
					<div className="cardHistoryItem-icon">
						{period.type === CardType.AlreadyRead ? (
							<Check />
						) : period.type === CardType.WantRead ? (
							<Schedule />
						) : (
							<Play />
						)}
					</div>

					<div className="cardHistoryItem-payload">
						<div className="cardHistoryItem-payload__type">
							{getReadableCardType(period.type)}
						</div>

						<div>{datePeriod ? datePeriod : "дата не указана"}</div>
					</div>

					{(controlsVisible || isDesktop) && (
						<div className="cardHistoryItem-controls">
							{period.start && (
								<div
									className="cardHistoryItem-control cardHistoryItem-control__calendar"
									onClick={() => goToCalendar(period.start)}
								>
									Календарь
								</div>
							)}

							{period.type === CardType.AlreadyRead ? (
								<>
									<div
										className="cardHistoryItem-control cardHistoryItem-control__edit"
										onClick={() => editHistory(period)}
									>
										Изменить
									</div>

									<div
										className="cardHistoryItem-control cardHistoryItem-control__delete"
										onClick={() => remove(period.id)}
									>
										Удалить
									</div>
								</>
							) : (
								<div
									className="cardHistoryItem-control cardHistoryItem-control__edit"
									onClick={edit}
								>
									Изменить
								</div>
							)}
						</div>
					)}
				</div>
			</OutsideClickHandler>
		</div>
	);
};

export default CardHistoryItem;